/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
const formFooterWrapperStyles = css({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBlockStart: "var(--ds-space-300, 24px)"
});
const justifyContentStyles = css({
  justifyContent: 'flex-start'
});

/**
 * __Form footer__
 *
 * A form footer has the content to be shown at the bottom of the form. This is usually the submit button.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */
export default function FormFooter({
  align = 'end',
  children
}) {
  return jsx("footer", {
    css: [formFooterWrapperStyles, align === 'start' && justifyContentStyles]
  }, children);
}